module.exports = __webpack_public_path__ + "media/assets/images/icons/studies/rightCarouselArrow-d07823b9a5a8c2a9864fae5bc48f530e.svg";